import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UsersComponent } from './users.component';
import { UsersService } from './users.service';
import { AuthenticationService } from '../login/authentication.service';

const routes: Routes = [
    {
        path: 'users',
        component: UsersComponent,
        data: {
            title: 'Users'
        }
    }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [
      UsersService,
      AuthenticationService
  ]
})
export class UsersRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/pages/users/users-routing.module.ts